var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hidden && _vm.resolvedUrl)?_c('img',_vm._b({attrs:{"src":_vm.resolvedUrl,"alt":_vm.alt,"aria-hidden":_vm.decorative ? 'true' : null},on:{"load":function($event){return _vm.$emit('load', $event)},"error":_vm.handleError}},'img',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }